import Loadable from 'react-loadable';

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import retry from '@rover/rsdk/src/modules/Network/retry';
import Route from '@rover/types/src/Route';

import Loading from '../client/Loading';

const Throw404 = Loadable({
  loader: () =>
    retry(() => import(/* webpackChunkName: "Throw404" */ '@rover/shared/js/pages/error/Throw404')),
  loading: Loading,
});

const route: Route = {
  component: Throw404,
  componentName: 'Throw404',
  path: '/*',
  exact: true,
  pageName: 'ssr-error-404',
  pageCategory: 'ssr-error',
  cacheTag: ['page-error', 'page-all'],
  concept: CONCEPTS.platform.web_client,
  isReactQueryRoute: false,
};
export default route;
